import { mainAxios } from "libs/axios";

export const getInfoShinhanApi = () => {
  return mainAxios.request({
    methodType: "GET",
    url: `/shinhan/my-balance`,
    requiresToken: true,
    notError: true,
    getError: true,
  });
};

export const unlinkShinhanApi = (userId: string) => {
  return mainAxios.request({
    method: "GET",
    url: `/shinhan/unlink`,
    params: { id: userId },
    requiresToken: true,
    notError: true,
    getError: true,
  });
};
